import { RootState } from 'state/store';

export const selectCustomerName = (state: RootState) =>
    [state.customer.title, state.customer.firstName, state.customer.lastName]
        .filter(Boolean)
        .join(' ');
